import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';
import CheckroomOutlinedIcon from '@mui/icons-material/CheckroomOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import RestaurantOutlinedIcon from '@mui/icons-material/RestaurantOutlined';
import ChairOutlinedIcon from '@mui/icons-material/ChairOutlined';
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined';
import RealEstateAgentOutlinedIcon from '@mui/icons-material/RealEstateAgentOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import PetsOutlinedIcon from '@mui/icons-material/PetsOutlined';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import DirectionsBusOutlinedIcon from '@mui/icons-material/DirectionsBusOutlined';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';

export const getRequestTypeIcon = (requestType: string) => {
    const name = requestType?.trim().toLowerCase() ?? '';

    if (name.includes('citizenship') || name.includes('visa') || name.includes('work permit') || name.includes('immigration')) {
        return { icon: <PublicOutlinedIcon fontSize="small" />, color: '#2563eb', background: '#eff6ff' };
    }

    if (name.includes('government benefit') || name.includes('benefit')) {
        return { icon: <AccountBalanceOutlinedIcon fontSize="small" />, color: '#16a34a', background: '#f0fdf4' };
    }

    if (name.includes('phone') || name.includes('telephone')) {
        return { icon: <PhoneOutlinedIcon fontSize="small" />, color: '#7c3aed', background: '#f5f3ff' };
    }

    if (name.includes('section-8') || name.includes('section 8')) {
        return { icon: <HomeOutlinedIcon fontSize="small" />, color: '#f97316', background: '#fff7ed' };
    }

    if (name.includes('transitional housing')) {
        return { icon: <ApartmentOutlinedIcon fontSize="small" />, color: '#0891b2', background: '#ecfeff' };
    }

    if (name.includes('auto repair') || name.includes('car repair') || name.includes('vehicle repair')) {
        return { icon: <DirectionsCarOutlinedIcon fontSize="small" />, color: '#ef4444', background: '#fef2f2' };
    }

    if (name.includes('clothing') || name.includes('clothes')) {
        return { icon: <CheckroomOutlinedIcon fontSize="small" />, color: '#ec4899', background: '#fdf2f8' };
    }

    if (name.includes('education') || name.includes('school') || name.includes('college')) {
        return { icon: <SchoolOutlinedIcon fontSize="small" />, color: '#8b5cf6', background: '#f5f3ff' };
    }

    if (name.includes('employment')) {
        return { icon: <WorkOutlineOutlinedIcon fontSize="small" />, color: '#0d9488', background: '#f0fdfa' };
    }

    if (name.includes('family legal')) {
        return { icon: <GavelOutlinedIcon fontSize="small" />, color: '#b45309', background: '#fffbeb' };
    }

    if (name === 'food' || name.includes('food assistance')) {
        return { icon: <RestaurantOutlinedIcon fontSize="small" />, color: '#ea580c', background: '#fff7ed' };
    }

    if (name.includes('furniture')) {
        return { icon: <ChairOutlinedIcon fontSize="small" />, color: '#7c2d12', background: '#fff7ed' };
    }

    if (name.includes('housing repair')) {
        return { icon: <HandymanOutlinedIcon fontSize="small" />, color: '#475569', background: '#f1f5f9' };
    }

    if (name.includes('housing/rent assistance') || name.includes('rent assistance')) {
        return { icon: <RealEstateAgentOutlinedIcon fontSize="small" />, color: '#059669', background: '#ecfdf5' };
    }

    if (name.includes('obtain id') || name === 'id') {
        return { icon: <BadgeOutlinedIcon fontSize="small" />, color: '#0284c7', background: '#f0f9ff' };
    }

    if (name.includes('pet')) {
        return { icon: <PetsOutlinedIcon fontSize="small" />, color: '#ca8a04', background: '#fefce8' };
    }

    if (name.includes('dental')) {
        return { icon: <MedicalServicesOutlinedIcon fontSize="small" />, color: '#14b8a6', background: '#f0fdfa' };
    }

    if (name.includes('shopping')) {
        return { icon: <ShoppingCartOutlinedIcon fontSize="small" />, color: '#c026d3', background: '#fdf4ff' };
    }

    if (name.includes('transportation')) {
        return { icon: <DirectionsBusOutlinedIcon fontSize="small" />, color: '#4f46e5', background: '#eef2ff' };
    }

    if (name.includes('utility')) {
        return { icon: <BoltOutlinedIcon fontSize="small" />, color: '#eab308', background: '#fefce8' };
    }

    if (name.includes('vision')) {
        return { icon: <VisibilityOutlinedIcon fontSize="small" />, color: '#0ea5e9', background: '#f0f9ff' };
    }

    if (name.includes('updating request') || name.includes('updating notes')) {
        return { icon: <EditNoteOutlinedIcon fontSize="small" />, color: '#6366f1', background: '#eef2ff' };
    }

    return { icon: <DescriptionOutlinedIcon fontSize="small" />, color: '#64748b', background: '#f8fafc' };
};
